export const ZEME_USER_DATA = 'zeme_user_data';
export const ZEME_CHAT_ROOM_DATA = 'zeme_chat_room_data';
export const ZEME_TEMP_SESSION_TOKEN = 'zeme_session_token';
export const ZEME_SIGNUP_IN_PROGRESS = 'zeme_signup_in_progress';
export const ZEME_VERIFIED_PHONE = 'zeme_verified_phone';
export const ZEME_APPROVAL_DATA = 'zeme_unapproved_user_data';
export const ZEME_USER_LOCATION = 'zeme_user_location';
